var _path, _rect, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5272 46.9213H17.7971C14.8185 46.9213 12.4038 44.5066 12.4038 41.5281V6.47212C12.4038 3.49352 14.8185 1.07889 17.7971 1.07889H32.1708L46.9205 16.3431V41.5281C46.9205 44.5067 44.5058 46.9213 41.5272 46.9213Z",
    fill: "#EEF1F7",
    stroke: "#CBD0DC",
    strokeWidth: 2.15729
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 21.2129,
    width: 32.3593,
    height: 19.5347,
    rx: 3.77526,
    fill: "#D82042"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3623 35.7238V26.3877H8.57794C9.2798 26.3877 9.86125 26.5199 10.3223 26.7843C10.7834 27.0487 11.1284 27.4103 11.3575 27.8693C11.5865 28.3251 11.7011 28.8387 11.7011 29.4101C11.7011 29.9845 11.5851 30.5011 11.3531 30.96C11.124 31.4159 10.7775 31.7775 10.3135 32.045C9.85244 32.3094 9.27245 32.4416 8.57353 32.4416H6.36223V31.2472H8.45019C8.89363 31.2472 9.25337 31.1682 9.52941 31.0102C9.80546 30.8491 10.0081 30.6303 10.1373 30.3537C10.2665 30.0772 10.3311 29.7626 10.3311 29.4101C10.3311 29.0575 10.2665 28.7445 10.1373 28.471C10.0081 28.1975 9.80399 27.9832 9.52501 27.8282C9.24896 27.6732 8.88482 27.5957 8.43257 27.5957H6.72344V35.7238H5.3623Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2173 35.7238H13.2968V26.3877H16.3098C17.1937 26.3877 17.9528 26.5746 18.5871 26.9484C19.2215 27.3192 19.7075 27.8525 20.0452 28.5485C20.3858 29.2414 20.5562 30.0726 20.5562 31.0421C20.5562 32.0146 20.3844 32.8503 20.0408 33.5493C19.7001 34.2483 19.2068 34.7862 18.5607 35.1631C17.9146 35.5369 17.1335 35.7238 16.2173 35.7238ZM14.6579 34.493H16.1424C16.8296 34.493 17.4007 34.3592 17.8559 34.0918C18.3111 33.8213 18.6517 33.4308 18.8779 32.9202C19.104 32.4066 19.2171 31.7806 19.2171 31.0421C19.2171 30.3096 19.104 29.6881 18.8779 29.1776C18.6547 28.667 18.3214 28.2795 17.8779 28.0151C17.4345 27.7507 16.8839 27.6185 16.2261 27.6185H14.6579V34.493Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2488 35.7238V26.3877H27.8431V27.6003H23.6099V30.4449H27.4422V31.6529H23.6099V35.7238H22.2488Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf_icon.dabb0287bb2c294f1e33539a8d96ddfd.svg";
export { ForwardRef as ReactComponent };